import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router';

import { useUserSpaces } from './api/useUserSpaces';

const useSelectedSpace = () => {
  const { spaceSlug } = useParams();
  const { spaces } = useUserSpaces();

  const space = useMemo(
    () => spaces?.find(({ slug }) => slug === spaceSlug),
    [spaceSlug, spaces],
  );

  const buildUrlWithSpace = useCallback(
    (url: string) => `/s/${spaceSlug}/${url}`,
    [spaceSlug],
  );
  return {
    space: space?.id,
    buildUrlWithSpace,
    spaceData: space,
    spaceLimits: space?.planLimits,
    spaceFeatureFlags: space?.featureFlags ?? {},
  };
};

export default useSelectedSpace;
